import { MILLISECONDS_IN_SECONDS } from 'src/Constants/numeric'

const STORAGE_KEY = 'pendingSpotifyCuratorAuth'
const PENDING_TTL_MINUTES = 15
const SECONDS_IN_MINUTE = 60
const PENDING_TTL_MS =
  PENDING_TTL_MINUTES * SECONDS_IN_MINUTE * MILLISECONDS_IN_SECONDS

export const persistPendingSpotifyCuratorAuth = (): void => {
  sessionStorage.setItem(STORAGE_KEY, String(Date.now()))
}

export const hasPendingSpotifyCuratorAuth = (): boolean => {
  const startedAt = Number(sessionStorage.getItem(STORAGE_KEY))

  return Boolean(startedAt) && Date.now() - startedAt < PENDING_TTL_MS
}

export const clearPendingSpotifyCuratorAuth = (): void => {
  sessionStorage.removeItem(STORAGE_KEY)
}
